
import { BookingQuestion } from "../../../../types/bookingQuestions";

export interface Answer {
    question: string;
    answer: string;
    travelerNum?: number;
    unit?: string
}

export type QuestionAnswers = Answer[];

// Define priority order for questions
export const QUESTION_PRIORITY: Array<BookingQuestion['id']> = [
    'FULL_NAMES_FIRST',
    'FULL_NAMES_LAST',
    'PASSPORT_PASSPORT_NO',
    'PASSPORT_NATIONALITY',
    'PASSPORT_EXPIRY',
    'DATE_OF_BIRTH',
    'HEIGHT',
    'WEIGHT',
    'AGEBAND',
    'TRANSFER_ARRIVAL_MODE',
    'PICKUP_POINT',
    'TRANSFER_AIR_ARRIVAL_AIRLINE',
    'TRANSFER_AIR_ARRIVAL_FLIGHT_NO',
    'TRANSFER_ARRIVAL_DROP_OFF',
    'TRANSFER_ARRIVAL_TIME',
    'TRANSFER_PORT_ARRIVAL_TIME',
    'TRANSFER_PORT_CRUISE_SHIP',
    'TRANSFER_RAIL_ARRIVAL_LINE',
    'TRANSFER_RAIL_ARRIVAL_STATION',
    'TRANSFER_DEPARTURE_MODE',
    'TRANSFER_AIR_DEPARTURE_AIRLINE',
    'TRANSFER_AIR_DEPARTURE_FLIGHT_NO',
    'TRANSFER_DEPARTURE_PICKUP',
    'TRANSFER_DEPARTURE_TIME',
    'TRANSFER_PORT_DEPARTURE_TIME',
    'TRANSFER_RAIL_DEPARTURE_LINE',
    'TRANSFER_RAIL_DEPARTURE_STATION',
    'TRANSFER_DEPARTURE_DATE',
    'SPECIAL_REQUIREMENTS'
];

export const sortQuestionsByPriority = (questions: BookingQuestion[]): BookingQuestion[] => {
    return [...questions].sort((a, b) => {
        const indexA = QUESTION_PRIORITY.indexOf(a.id);
        const indexB = QUESTION_PRIORITY.indexOf(b.id);

        // If both questions are in priority array, sort by priority
        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        }

        // If only one question is in priority array, prioritize it
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;

        // If neither question is in priority array, maintain original order
        return 0;
    });
};